import { render } from "./Order.vue?vue&type=template&id=d43aa946&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=d43aa946&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d43aa946"

export default script